<template>
  <div
    :class="[
      subject == 1 ||
      subject == 2 ||
      subject == 3 ||
      subject == 4 ||
      subject == 5 ||
      subject == 6
        ? 'course' + subject
        : 'course',
      isNoviceClass ? 'novice_class' : '',
      'compose',
    ]"
  >
    <div class="header">
      <span @click="go_class" class="cursor"></span>
      <h2>{{ composeLessInfo.title }}</h2>
      <!--			<div class="coin">-->
      <!--				<img src="../../../assets/img/common/coin.png" style="width: 35px;margin-right: 7px;" alt="">-->
      <!--				<div>{{composeLessInfo.coin}}枚</div>-->
      <!--				<coinex></coinex>-->
      <!--			</div>-->
    </div>
    <!-- <div class="lottie"></div> -->
    <compose-list :subType="subType"></compose-list>
  </div>
</template>

<script>
import compose_list from "./compose_list";
import coinex from "@/components/basic/coinex.vue";
import { mapState, mapMutations } from "vuex";
import lottie from "lottie-web-limi";
export default {
  name: "courseCompose",
  data() {
    return {
      anim: "",
      subType: "",
    };
  },
  components: {
    "compose-list": compose_list,
    coinex,
  },
  computed: {
    ...mapState(["class_name", "subject", "isNoviceClass", "composeLessInfo"]),
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setLottieSize);
  },
  mounted() {
    // this.setLottieSize();
    // window.addEventListener("resize", this.setLottieSize);
    this.handleAnimation();
  },
  methods: {
    ...mapMutations(["saveComposeLessInfo"]),
    go_class() {
      //返回课时列表
      let obj = Object.assign(this.composeLessInfo, { showCompose: false });
      this.saveComposeLessInfo(obj);
    },
    handleAnimation() {
      // console.log('subject', this.subject)
      const subTypes = {
        1: "shuxue",
        2: "yuwen",
        3: "yingyu",
        4: "wuli",
        5: "huaxue",
        6: "kuaiji",
        7: "beiyong",
      };
      let subType = this.isNoviceClass
        ? 4
        : this.subject != 1 &&
          this.subject != 2 &&
          this.subject != 3 &&
          this.subject != 4 &&
          this.subject != 5 &&
          this.subject != 6
        ? 7
        : this.subject;
      this.subType = subTypes[subType];
      console.log(66, this.subType);
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".lottie"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: `/static/lottie/${this.subType}/a.json`,
      });
    },
    playAnim() {
      this.anim.play();
      // this.anim.goToAndStop(200)
    },
    setLottieBoxSize() {
      let clientWidth = document.body.clientWidth;
      let clientHeight = document.body.clientHeight;
      let scaleWindow = clientWidth / clientHeight;
      let scaleLottie = 1280 / 720;
      let lottieDom = document.querySelector(".lottie");
      let scale;
      let offset;
      if (scaleWindow > scaleLottie) {
        scale = clientWidth / 1280;
        lottieDom.style.height = 100 * scale + "%";
        lottieDom.style.width = "100%";
        offset = (100 * scale - 100) / 2;
        lottieDom.style.top = `-${offset}%`;
        lottieDom.style.left = `0`;
        if (clientHeight < 720) {
          let scaleY = 720 / clientHeight;
          console.log(scaleY);
          lottieDom.style.width = 100 * scale + "%";
          lottieDom.style.height = 720 * scaleY + "px";
          lottieDom.style.left = `-${(100 * scale - 100) / 2}%`;
        }
      } else if (scaleWindow < scaleLottie) {
        scale = 720 / clientHeight;
        lottieDom.style.width = 100 / scale + "%";
        lottieDom.style.height = "100%";
        offset = (100 / scale - 100) / 2;
        // console.log((100 / scale - 100),lottieDom.style.width)
        lottieDom.style.left = `-${offset}%`;
        lottieDom.style.top = `0`;
      }
    },
    setLottieSize() {
      let clientWidth = document.body.clientWidth;
      let clientHeight = document.body.clientHeight;
      let lottieDom = document.querySelector(".lottie");
      if (!lottieDom) return;
      if (clientHeight >= 720 && clientWidth >= 1280) {
        if (clientWidth / clientHeight > 1280 / 720) {
          lottieDom.style.width = "100%";
          lottieDom.style.height = (720 / 1280) * clientWidth + "px";
        } else {
          lottieDom.style.height = "100%";
          lottieDom.style.width = (1280 / 720) * clientHeight + "px";
        }
      } else if (clientHeight > 720 && clientWidth < 1280) {
        lottieDom.style.height = "100%";
        lottieDom.style.width = (1280 / 720) * clientHeight + "px";
      } else if (clientHeight < 720 && clientWidth < 1280) {
        lottieDom.style.height = "720px";
        lottieDom.style.width = "1280px";
      } else if (clientHeight < 720 && clientWidth > 1280) {
        lottieDom.style.width = "100%";
        lottieDom.style.height = (720 / 1280) * clientWidth + "px";
      }
    },
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.course,
.course1,
.course2,
.course3 {
  width: 100%;
  height: 100%;
  background: url(/static/img/common/space.jpg) no-repeat;
  position: relative;
  overflow: hidden;
  background-size: cover;
}
.lottie {
  width: 100%;
  height: 720px;
  position: absolute;
  z-index: 0;
}
// .course1 {
//   background: url(/static/img/course/bg1.png) no-repeat;
//   background-size: cover;
// }
// .course2 {
//   background: url(/static/img/course/bg2.png) no-repeat;
//   background-size: cover;
// }
// .course3 {
//   background: url(/static/img/course/bg3.png) no-repeat;
//   background-size: cover;
// }
.novice_class {
  background: url(/static/img/course/novice_bg.png) no-repeat;
  background-size: cover;
}
.header {
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 83px;
  padding-top: 20px;
  .coin {
    position: absolute;
    top: 25px;
    right: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-radius: 40px;
    padding: 0 12px;
    background: rgba(255, 255, 255, 0.26);
    color: #fff;
    font-size: 18px;
    div {
      margin-right: 4px;
    }
  }
  span {
    position: absolute;
    width: 56px;
    height: 56px;
    background: url("../../../assets/img/common/arrow_left1.png") no-repeat
      center center;
    background-size: 100% 100%;
    border-radius: 50%;
    left: 30px;
    top: 20px;
    &:hover {
      background: rgba(0, 0, 0, 0.08)
        url("../../../assets/img/common/arrow_left1.png") no-repeat center
        center;
      background-size: 100% 100%;
    }
  }
  h2 {
    font-family: PingFang_Medium;
    font-weight: normal;
    font-size: 30px;
    padding-top: 10px;
    color: #fff;
  }
  i {
    position: absolute;
    top: 10px;
    right: 30px;
    width: auto;
    height: 50px;
    font-family: Roboto_Regular;
    background: rgba(0, 0, 0, 0.15) url(../../../assets/img/common/coin.png)
      no-repeat left center;
    border-radius: 25px;
    background-size: 50px 50px;
    font-size: 24px;
    line-height: 50px;
    color: #007a9c;
    text-align: center;
    padding: 0 22px 0 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/courseCompose/courseCompose.vue